import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/events.js";
import "./navigator.js";
import "./form.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.Assessment = class Assessment extends Backbone.View {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
    this.selectCompletionPage = this.selectCompletionPage.bind(this);
    this.showQuestionNavigator = this.showQuestionNavigator.bind(this);
    this.showAssessmentForm = this.showAssessmentForm.bind(this);
    this.showIntroForm = this.showIntroForm.bind(this);
    this.showSubmitterInfoForm = this.showSubmitterInfoForm.bind(this);
    this.showQuestionForm = this.showQuestionForm.bind(this);
    this.showCompletionPageForm = this.showCompletionPageForm.bind(this);
    this.swapEditorView = this.swapEditorView.bind(this);
  }

  initialize(options = {}) {
    this.selectItems = options.selectItems || {};
    this.navigator = new AssessmentBuilder.Views.AssessmentNavigator({ model: this.model }).render();

    return (this.form = new AssessmentBuilder.Views.AssessmentForm({
      model: this.model,
      selectItems: this.selectItems,
    }).render());
  }

  render() {
    this.$el.append(this.template(this.model.attributes));
    this.showQuestionNavigator();
    this.showAssessmentForm();
    return this;
  }

  // HELPER METHODS

  unselectIntro() {
    return this.showAssessmentForm();
  }

  selectIntro() {
    return this.showIntroForm();
  }

  unselectSubmitterInfo() {
    return this.showAssessmentForm();
  }

  selectSubmitterInfo() {
    return this.showSubmitterInfoForm();
  }

  unselectQuestion() {
    return this.showAssessmentForm();
  }

  selectQuestion(question) {
    return this.showQuestionForm(question);
  }

  unselectCompletionPage() {
    return this.showAssessmentForm();
  }

  selectCompletionPage(completionPage) {
    return this.showCompletionPageForm(completionPage);
  }

  showQuestionNavigator() {
    return this.$(".navigator-container").html(this.navigator.el);
  }

  showAssessmentForm() {
    return this.swapEditorView(this.form, { retainObservers: true });
  }

  showIntroForm() {
    return this.swapEditorView(new AssessmentBuilder.Views.IntroForm({ model: this.model.get("intro") }).render());
  }

  showSubmitterInfoForm() {
    return this.swapEditorView(
      new AssessmentBuilder.Views.SubmitterInfoForm({
        model: this.model.get("submitterInfo"),
        selectItems: this.selectItems,
      }).render(),
    );
  }

  showQuestionForm(question) {
    return this.swapEditorView(
      new AssessmentBuilder.Views.QuestionForm({
        model: question,
        selectItems: this.selectItems,
      }).render(),
    );
  }

  showCompletionPageForm(completionPage) {
    return this.swapEditorView(
      new AssessmentBuilder.Views.CompletionPageForm({
        model: completionPage,
        selectItems: this.selectItems,
      }).render(),
    );
  }

  swapEditorView(view, options = {}) {
    if (this.editor != null ? this.editor.retainObservers : undefined) {
      jQuery(this.editor.view.el).detach();
    }
    this.editor = options;
    this.editor.view = view;
    return this.$(".editor-container").html(view.el);
  }
};
AssessmentBuilder.Views.Assessment.prototype.tagName = "assessment-builder";
AssessmentBuilder.Views.Assessment.prototype.template = _.template(AssessmentBuilder.Templates.Assessment.assessment);

AssessmentBuilder.Views.Assessment.prototype.events = {
  [`${AssessmentBuilder.Events.AssessmentNavigator.introSelected} .navigator-container`]: "selectIntro",
  [`${AssessmentBuilder.Events.AssessmentNavigator.introUnselected} .navigator-container`]: "unselectIntro",
  [`${AssessmentBuilder.Events.AssessmentNavigator.submitterInfoSelected} .navigator-container`]: "selectSubmitterInfo",
  [`${AssessmentBuilder.Events.AssessmentNavigator.submitterInfoUnselected} .navigator-container`]:
    "unselectSubmitterInfo",
  [`${AssessmentBuilder.Events.AssessmentNavigator.questionSelected} .navigator-container`](_, question) {
    return this.selectQuestion(question);
  },
  [`${AssessmentBuilder.Events.AssessmentNavigator.questionUnselected} .navigator-container`]: "unselectQuestion",
  [`${AssessmentBuilder.Events.AssessmentNavigator.completionPageSelected} .navigator-container`](_, completionPage) {
    return this.selectCompletionPage(completionPage);
  },
  [`${AssessmentBuilder.Events.AssessmentNavigator.completionPageUnselected} .navigator-container`]:
    "unselectCompletionPage",
};
